
import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-20 sm:pt-24 md:pt-28 pb-12 md:pb-16 lg:pb-20 page-container">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-autocare-blue mb-6 md:mb-8">
            About AutoCare
          </h1>
          
          <div className="prose max-w-none space-y-6 md:space-y-8">
            <p className="text-base md:text-lg text-gray-600">
              Founded in 2024, AutoCare is a Palestinian graduation project developed to enhance the oil change experience through a smart, AI-assisted platform. Designed by students from An-Najah National University, the platform helps car owners find the right engine oil and nearby service providers with ease and confidence.
            </p>
            
            <p className="text-base md:text-lg text-gray-600">
              Our goal is to digitize and simplify the oil change process by offering an intelligent oil matching tool (Oil Finder), verified service shop listings, and a seamless booking experience.
            </p>
            
            <div className="bg-autocare-gray-light p-6 md:p-8 rounded-lg my-8 md:my-12">
              <h2 className="text-xl md:text-2xl font-semibold text-autocare-blue mb-4 md:mb-6">Our Mission</h2>
              <p className="text-gray-700 text-base md:text-lg">
                To empower car owners in Palestine by providing a smart and accessible platform for engine oil services. We aim to simplify oil selection, connect users with reliable service providers, and improve overall vehicle care through digital convenience, transparency, and trust.
              </p>
            </div>
            
            <h2 className="text-xl md:text-2xl font-semibold text-autocare-blue mb-4 md:mb-6">What Sets Us Apart</h2>
            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-12">
              <li className="flex items-start">
                <span className="text-autocare-blue font-bold mr-2 mt-1">✓</span>
                <span className="text-base md:text-lg">Smart Oil Finder that recommends the right oil based on your car details</span>
              </li>
              <li className="flex items-start">
                <span className="text-autocare-blue font-bold mr-2 mt-1">✓</span>
                <span className="text-base md:text-lg">Verified list of local oil change shops across Palestinian cities</span>
              </li>
              <li className="flex items-start">
                <span className="text-autocare-blue font-bold mr-2 mt-1">✓</span>
                <span className="text-base md:text-lg">Simple booking experience through our website</span>
              </li>
              <li className="flex items-start">
                <span className="text-autocare-blue font-bold mr-2 mt-1">✓</span>
                <span className="text-base md:text-lg">Clear product details and transparent pricing</span>
              </li>
              <li className="flex items-start">
                <span className="text-autocare-blue font-bold mr-2 mt-1">✓</span>
                <span className="text-base md:text-lg">A student-led innovation that combines technology with real market needs</span>
              </li>
            </ul>
            
            <h2 className="text-xl md:text-2xl font-semibold text-autocare-blue mb-4 md:mb-6">Our Team</h2>
            <p className="text-gray-700 mb-8 md:mb-12 text-base md:text-lg">
              Our team consists of automotive enthusiasts, tech innovators, and customer service experts dedicated to improving the auto maintenance experience for vehicle owners across Palestine.
            </p>
            
            <div className="mt-10 md:mt-12 flex justify-center">
              <Button onClick={() => navigate('/contact')} className="bg-autocare-blue hover:bg-autocare-blue-light text-white px-6 py-3">
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default About;
